import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
	Grid,
  TextField,
  MenuItem,
  Button,
} from '@mui/material';
import { Text } from 'shared/components';

const MergeDrawer = ({ indicators, selected, onMerge }) => {

  const { values, setFieldValue, errors, handleSubmit } = useFormik({
    initialValues: {
      targetId: null,
    },
    onSubmit: (values, { resetForm }) => {
      onMerge({
        ...values,
        indicatorList: JSON.stringify(selected.map(se => se.dbId))
      }, resetForm);
    },
		validate: (values) => {
      const errors = {};
			if (!values.targetId) errors.targetId = 'Please select a target indicator';
			return errors;
    }
  });

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid items xs={12} style={{marginTop: '10px'}}>
        The following indicators will be merged to the targeted indicator:
      </Grid>
      { selected.map(ind => (
        <Grid item xs={12} style={{marginTop: '10px'}}>
          <Text variant="body1"><b>{`Name: ${ind.name} | ID: ${ind.dbId}`}</b></Text>
        </Grid>
      ))}
      <Grid items xs={4}>Target indicator:</Grid>
      <Grid item xs={8}>
        <TextField
          value={values.targetId}
          defaultValue={values.targetId}
          onChange={(_, { props }) => setFieldValue('targetId', props.value)}
          error={errors.targetId}
          select
          fullWidth
        >
          { indicators.map(item => (<MenuItem key={item.dbId} value={item.dbId}>{`${item.dbId} - ${item.name}`}</MenuItem>))}
        </TextField>
      </Grid>
      <Grid items xs={12} style={{marginTop: '10px'}}>
        By clicking "MERGE" your confirm to merge all the selected indicators into the targeted one, this action is not reversible.
      </Grid>
      <Grid item xs={12} style={{marginTop: '10px'}}>
        <Button onClick={handleSubmit} style={{float: 'right'}}>MERGE</Button>
      </Grid>
  </Grid>
  );
};

export default MergeDrawer;
